import React, { useEffect, useState } from 'react';

import { Waveform } from '@uiball/loaders';
import Button from '../utils/Button/Button';
import {
  ButtonModalCancel,
  XIcon,
  InputCardCvcElement,
  InputCardExpiryElement,
  InputCardNumberElement,
  InputRow,
  ModalButtonsContainer,
  ModalTitle,
  TitleContainer,
  Total,
  TotalContainer,
  TotalNumber,
  TotalRow,
} from './PaymentCardFormModal.styles';
import { CardNumberElement, useElements } from '@stripe/react-stripe-js';
import { addPaymentMethod, subscribeAndAddPaymentMethod } from '../../store/slice/vendor/asyncThunks';
import { useDispatch, useSelector } from 'react-redux';
import InputComponent from '../utils/Input/Input';
import {
  selectAddPaymentMethodPending,
  selectSubscribeAndAddPaymentMethodPending,
  selectUserInfo,
} from '../../store/slice/vendor/slice';
import { notifyErrorLeft } from '../../utils/notify';
import Modal from './Modal';

const PaymentCardFormModal = ({
  modalOpen,
  onClose,
  cancelDisabled,
  loading,
  width,
  height,
  notShowButtons,
  rightButtonTitle,
  stripe,
}) => {
  const elements = useElements();
  const cardNumberElement = elements.getElement(CardNumberElement);
  const dispatch = useDispatch();
  const [name, setName] = useState('');
  const vendorInfo = useSelector(selectUserInfo);

  const subscribeAndAddPaymentMethodPending = useSelector(selectSubscribeAndAddPaymentMethodPending);
  const addPaymentMethodPending = useSelector(selectAddPaymentMethodPending);

  const [hasCardError, setHasCardError] = useState(true);
  const [hasDateError, setHasDateError] = useState(true);
  const [hasCVCError, setHasCVCError] = useState(true);

  const isChanging = vendorInfo.subscription && !vendorInfo.subscription.canceledAt;
  const handleAddPayment = async () => {
    if (!stripe || !elements) {
      return;
    }

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardNumberElement,
      billing_details: {
        name: name,
      },
    });
    if (error) {
      console.log(error);
      notifyErrorLeft('Payment provider currently unavailable. Try again later.');
    } else if (paymentMethod) {
      if (vendorInfo.subscription && !vendorInfo.subscription.canceledAt) {
        dispatch(addPaymentMethod({ paymentMethodId: paymentMethod.id }))
          .unwrap()
          .then(() => {
            onClose();
          })
          .catch(err => {
            console.log(err);
            notifyErrorLeft(err.message);
          });
      } else {
        dispatch(subscribeAndAddPaymentMethod({ paymentMethodId: paymentMethod.id }))
          .unwrap()
          .then(() => {
            onClose();
          })
          .catch(err => {
            console.log(err);
            notifyErrorLeft(err.message);
          });
      }
    }
  };

  const handleKeyDown = e => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
  return (
    <Modal
      isOpen={modalOpen}
      width={width}
      height={height}
      onClose={() => {
        !cancelDisabled && onClose();
      }}
      fade>
      <div>
        <TitleContainer>
          <ModalTitle>{!isChanging ? 'Subscribe Now' : 'Change Payment Method'}</ModalTitle>
          <XIcon
            onClick={() => {
              !cancelDisabled && onClose();
            }}
          />
        </TitleContainer>
        <InputComponent
          placeholder={'Name on the card'}
          value={name}
          onChange={e => setName(e.target.value)}
          noOpacity={true}
        />
        <InputCardNumberElement
          options={{
            placeholder: 'Card Number',
            style: {
              base: {
                fontFamily: 'Poppins-Medium',
                fontSize: '16px',
                textAlign: 'justify',
                '::placeholder': {
                  color: '#000',
                },
              },
              invalid: {
                color: '#9e2146',
              },
            },
          }}
          onChange={e => {
            if (e.error || !e.complete) {
              setHasCardError(true);
            } else {
              setHasCardError(false);
            }
          }}
        />

        <InputRow>
          <InputCardExpiryElement
            options={{
              placeholder: 'Date',
              style: {
                base: {
                  fontFamily: 'Poppins-Medium',
                  fontSize: '16px',
                  textAlign: 'justify',
                  '::placeholder': {
                    color: '#000',
                  },
                },
                invalid: {
                  color: '#9e2146',
                },
              },
            }}
            onChange={e => {
              if (e.error || !e.complete) {
                setHasDateError(true);
              } else {
                setHasDateError(false);
              }
            }}
          />
          <InputCardCvcElement
            options={{
              placeholder: 'CVC',
              style: {
                base: {
                  fontFamily: 'Poppins-Medium',
                  fontSize: '16px',
                  textAlign: 'justify',
                  '::placeholder': {
                    color: '#000',
                  },
                },
                invalid: {
                  color: '#9e2146',
                },
              },
            }}
            onChange={e => {
              if (e.error || !e.complete) {
                setHasCVCError(true);
              } else {
                setHasCVCError(false);
              }
            }}
          />
        </InputRow>
        {!isChanging && (
          <TotalContainer>
            <TotalRow>
              <Total>{'Subtotal:'}</Total>
              <TotalNumber>{' $29.00'}</TotalNumber>
            </TotalRow>
            <TotalRow>
              <Total>{'Total'}</Total>
              <TotalNumber>{' $29.00'}</TotalNumber>
            </TotalRow>
          </TotalContainer>
        )}
      </div>
      {!notShowButtons && (
        <ModalButtonsContainer>
          <ButtonModalCancel onClick={onClose} disabled={cancelDisabled}>
            Cancel
          </ButtonModalCancel>
          {!loading ? (
            <Button
              title={rightButtonTitle ? rightButtonTitle : isChanging ? 'Change' : 'Subscribe'}
              disabled={
                !name.trim() ||
                hasCardError ||
                hasCVCError ||
                hasDateError ||
                subscribeAndAddPaymentMethodPending ||
                addPaymentMethodPending
              }
              containerStyle={{ width: '160px' }}
              onClick={() => {
                handleAddPayment();
              }}
              loading={subscribeAndAddPaymentMethodPending || addPaymentMethodPending}
            />
          ) : (
            <Waveform size={26} lineWeight={3.5} speed={1} color="black" />
          )}
        </ModalButtonsContainer>
      )}
    </Modal>
  );
};

export default PaymentCardFormModal;
